"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mkPayee = exports.mkPayeeListStore = void 0;
const immutable_1 = require("immutable");
exports.mkPayeeListStore = (0, immutable_1.Record)({
    payeesByAccountId: (0, immutable_1.Map)(),
    isLoading: false,
    loadPending: false,
});
exports.mkPayee = (0, immutable_1.Record)({
    id: null,
    name: null,
    amountString: null,
    catString: null,
    tagString: null,
    txn: null,
    count: 0,
});
